import { render, staticRenderFns } from "./AuralizationPlayButton.vue?vue&type=template&id=6dd17127&scoped=true&"
import script from "./AuralizationPlayButton.vue?vue&type=script&lang=js&"
export * from "./AuralizationPlayButton.vue?vue&type=script&lang=js&"
import style0 from "./AuralizationPlayButton.vue?vue&type=style&index=0&id=6dd17127&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd17127",
  null
  
)

export default component.exports